import {
  AfterViewInit,
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
} from '@angular/core';

import { Chart, ChartOptions } from 'chart.js';

import 'chartjs-plugin-colorschemes';
import { PieCharData } from 'src/app/modules/dashboard/utils/pie_char_data';
import { ICase } from '../../interfaces/case.interface';

@Component({
  selector: 'cases-data-popover',
  templateUrl: './cases-data-popover.component.html',
  styleUrls: ['./cases-data-popover.component.scss'],
})
export class CasesDataPopoverComponent implements OnInit, AfterViewInit {
  @Input() status: 'initial' | 'toFinalize' | 'running' | 'tobeApproved';
  @Input() data: ICase[];

  @Input() view = false;
  @Output() hidden = new EventEmitter<boolean>();

  @HostListener('click')
  clickInside() {
    this.focusComponent = true;
  }

  @HostListener('document:click')
  clickout() {
    if (this.focusComponent && this.view) {
      this.focusComponent = false;
    } else {
      this.hidden.emit(true);
      this.focusComponent = true;
    }
  }
  focusComponent = true;

  constructor() {}

  ngOnInit() {}

  addDataChart(iCase: ICase) {
    const { name } = iCase.caseType;

    let index = this.dataChart.labels.findIndex((x) => x == name);

    if (index != -1) {
      this.dataChart.data[index]++;
    } else {
      this.dataChart.labels.push(name);
      this.dataChart.data.push(1);
    }
  }

  dataChart = {
    labels: [],
    data: [],
  };

  ngAfterViewInit(): void {
    for (const key of this.data) {
      this.addDataChart(key);
    }
    this.createChart();
  }
  pie: Chart;
  createChart() {
    let id = `pie${this.status}`;

    this.pie = new Chart(id, {
      type: 'doughnut',
      data: {
        labels: this.dataChart.labels,
        datasets: [
          {
            label: 'data',
            data: this.dataChart.data,

            borderWidth: 1,
          },
        ],
      },

      options: this.getChartOptions(),
    });
  }

  /**
   *  Opciones del grafico
 
   */
  getChartOptions(): ChartOptions {
    return {
      plugins: {
        colorschemes: {
          scheme: 'office.Parallax6',
        },
      },
      responsive: false,
      cutoutPercentage: 65,
      legend: {
        display: true,
        position: 'left',

        labels: {
          fontColor: '#000',
          padding: 10,
        },
      },
    };
  }
}
